import styles from './radio.module.scss'

type Props = {}

const CustomRadioButton = ({ label, children, checked, onChange, value }: any) => {
    return (
        <label className={styles.customRadio}>
            <input type="radio" checked={checked} onChange={onChange} value={value} />
            <span className={styles.customRadioButton}></span>
            {label}
            {children}
        </label>
    )
}

export default CustomRadioButton
